function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterZeusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4891 4.9029L16.467 4.81367C16.4202 4.62631 16.2359 4.49351 16.0232 4.49351H12.8092C12.7951 4.49351 12.7803 4.49439 12.7661 4.49558H11.2823L12.1448 1.46383C12.1794 1.3414 12.1498 1.21096 12.0635 1.11106C11.9773 1.01116 11.8446 0.952759 11.7043 0.952759H2.00319C1.7961 0.952759 1.61502 1.07875 1.563 1.25958L0.51506 4.89638C0.479503 5.0194 0.509134 5.14984 0.595393 5.25003C0.681651 5.34994 0.814332 5.40863 0.955243 5.40863H4.36707L2.70511 10.4257C2.65046 10.5899 2.71532 10.7669 2.86676 10.8698C2.94775 10.9249 3.04422 10.9528 3.14101 10.9528C3.22595 10.9528 3.3109 10.9314 3.38596 10.8884L3.50053 10.8223L16.2408 5.36239C16.4328 5.28027 16.5358 5.08936 16.4891 4.9029ZM3.32176 10.3243L5.11706 4.90497H1.0899L2.08418 1.45642H9.92812L8.86668 4.99895H12.641L3.32176 10.3243Z",
    fill: "#C3C3CC",
    style: {
      fill: "#C3C3CC",
      fill: "color(display-p3 0.7647 0.7647 0.8000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6404 4.99895H10.6683H8.8727H8.86611L9.92756 1.45642H2.08394L1.08966 4.90527H5.11682L3.32152 10.3243L12.6404 4.99895Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.5 0.952759)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterZeusLogo);
export default __webpack_public_path__ + "static/media/footer-zeus-logo.c63cf03575f754acfe16a012e5baf301.svg";
export { ForwardRef as ReactComponent };